import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable, { TouchableProps } from '@sport1/react-elements/Touchable'
import LabelFont from '../../Theme/Fonts/Label'
import { RequireAtLeastOne } from '../../utils/types/requireAtLeastOne'
import Image from '../../BaseComponents/Image'
import { TestID } from '../../utils/PropTypesDefinitions'

export type ProfileListProps = TestID &
    RequireAtLeastOne<
        {
            /** a string number shown on the left side (cannot be used with imageUrl together) */
            listingNumber?: string
            /** an image on the left side (cannot be used with listingNumber) */
            imageUrl?: string
            /** alt text for the image */
            alt?: string
            /** text shown in the center */
            text: string
            /** props like onPress and href to handle the press on the row */
            touchableProps?: TouchableProps
        },
        'listingNumber' | 'imageUrl'
    >

const ProfileList: FC<ProfileListProps> = ({
    listingNumber,
    imageUrl,
    alt,
    text,
    touchableProps,
    testID,
}) => (
    <Touchable {...touchableProps}>
        <Grid
            noExpand
            horizontal
            paddingY={4}
            paddingX={5}
            borderTop={1}
            borderColor="onyx-opacity-12"
            backgroundColor="pearl"
            testID={testID}
        >
            <Grid noExpand width={30} marginRight={3}>
                {listingNumber ? (
                    <LabelFont bold numberOfLines={1} color="onyx">
                        {listingNumber}
                    </LabelFont>
                ) : (
                    <Image size="L" imageUrl={imageUrl} alt={alt} aspectRatio="1:1" width={16} />
                )}
            </Grid>
            <Grid>
                <LabelFont color="onyx">{text}</LabelFont>
            </Grid>
        </Grid>
    </Touchable>
)

export default ProfileList
